export const baseURL = process.env.REACT_APP_API_URL + "/api";
//export const baseURL = "https://api.ncseries.gg/api";
export const baseURLnoapi = process.env.REACT_APP_API_URL;

//export const baseURLnoapi = "https://api.ncseries.gg";
export const powerStatsAPI = "https://api.rising.powerstats.dk/RisingStats/api"

// Season Configuration
export const CURRENT_SEASON = 3;
export const AVAILABLE_SEASONS = [3, 2, 1]; // Ordered from newest to oldest
export const OLDEST_SEASON = 1;
export const LATEST_SEASON = 3;

// Season Display Names (optional, for UI)
export const SEASON_NAMES: Record<number, string> = {
  1: "Season 1 - Winter 2024",
  2: "Season 2 - Spring 2025",
  3: "Season 3 - Winter 2025"
};
